import { Injectable, inject } from '@angular/core';
import { EnumService } from '@backoffice-frontend/shared/bo/util-masterdata';
import { MarketWidget, MarketWidgetDataSource } from '@clean-code/models';
import { EnumValue, ID } from '@clean-code/models/common';
import { cloneObject } from '@clean-code/shared/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MarketWidgetDataService {
  private graphqlService = inject(GraphqlService);
  private enumService = inject(EnumService);
  public static readonly marketWidgetParams = `
        id
        name
        settings
        dataSources
        {
            settings
        }
        groupId
    `;

  private readonly entityName = 'marketWidget';
  private readonly inputModelName = 'MarketWidgetInput';

  getAll$(id: ID): Observable<MarketWidget[]> {
    const query = `
            query($id: Int!) {
                ${this.entityName}GetAll(id: $id) {
                    ${MarketWidgetDataService.marketWidgetParams}
                }
            }
        `;

    return this.graphqlService.query<MarketWidget[]>(query, { id });
  }

  getById$(id: ID): Observable<MarketWidget> {
    const query = `
            query($id: Int!) {
                ${this.entityName}GetById(id: $id) {
                    ${MarketWidgetDataService.marketWidgetParams}
                }
            }
        `;

    return this.graphqlService.query<MarketWidget>(query, { id });
  }

  add$(input: MarketWidget): Observable<MarketWidget> {
    const mutation = `
            mutation ($input: ${this.inputModelName}!) {
                ${this.entityName}Add(input: $input)
                {
                    ${MarketWidgetDataService.marketWidgetParams}
                }
            }
        `;

    const clone = cloneObject(input);
    this.updateSettings(clone);

    const variables = {
      input: clone,
      // input: {
      //   ...clone,
      //   dataSources: clone.dataSources.map((x: any) => {
      //     return {
      //       ...x,
      //       identifier: (x.identifier as any).identifier,
      //     };
      //   }),
      // },
    };

    return this.graphqlService.mutation<MarketWidget>(mutation, variables);
  }

  update$(input: MarketWidget): Observable<MarketWidget> {
    const mutation = `
            mutation ($input: ${this.inputModelName}!) {
                ${this.entityName}Update(input: $input)
                {
                    ${MarketWidgetDataService.marketWidgetParams}
                }
            }
        `;

    const clone = cloneObject(input);
    this.updateSettings(clone);

    const variables = {
      input: clone,
      // input: {
      //   ...clone,
      //   dataSources: clone.dataSources.map((x: any) => {
      //     return {
      //       ...x,
      //       identifier: (x.identifier as any).identifier,
      //     };
      //   }),
      // },
    };

    return this.graphqlService.mutation<MarketWidget>(mutation, variables);
  }

  delete$(id: ID): Observable<boolean> {
    const mutation = `
            mutation {
                ${this.entityName}Delete(id: ${id})
            }
        `;

    return this.graphqlService.mutation<boolean>(mutation);
  }

  private updateSettings(value: MarketWidget) {
    const payload = value;
    (payload.settings as unknown) = JSON.stringify(payload.settings);

    payload.dataSources.forEach((x: MarketWidgetDataSource) => {
      (x.settings as unknown) = JSON.stringify(x.settings); //data is sent as json string to backend
    });
  }

  public timeFrames$(): Observable<EnumValue[]> {
    return this.enumService.getEnumType$('TimeSeriesTimeFrame');
  }
}
